import * as s from "../../LoginStyled";
import * as cs from "../../../SignCommonStyled";
import { ValidateWord, UnderlineText } from "components/atoms/text/Text";
import { Validate, ValidateMsg } from "api/interfaces/commonInterface.interface";
import {
  LOGIN_STEP,
  LoginInfo,
} from "../../LoginContainer";
import { COLORS } from "styles/colors";
import PasswordInput from "components/atoms/input/PasswordInput";
import BigButton from "components/atoms/buttons/BigButton";
import ForgotPassword from "../../forgot/ForgotPassword";

interface Props {
  loginInfo: LoginInfo;
  isValidated: Validate;
  validateMsg: ValidateMsg;
  onChangeLoginInfo: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onChangeStep: (step: LOGIN_STEP) => void;
  handleClick: () => void;
  step: LOGIN_STEP;
  autoFocus?: boolean;
}

export default function InputPassword({
  loginInfo,
  isValidated,
  validateMsg,
  onChangeLoginInfo,
  onChangeStep,
  handleClick,
  step,
  autoFocus = true,
}: Props) {
  return (
    <>
      <s.InputWrapper>
        {step !== LOGIN_STEP.SETUP_PASSKEY && (
          <s.EmailBadge>{loginInfo.email}</s.EmailBadge>
        )}

        <PasswordInput
          value={loginInfo.password}
          isValidated={isValidated.password}
          onChange={onChangeLoginInfo}
          onEnter={handleClick}
          autoFocus={autoFocus}
          data-testid="auth-signin-email-password-input-change-login-info"
        />

        {validateMsg.password && (
          <s.ValidateWrapper>
            <ValidateWord data-testid="auth-signin-email-validate-password">
              {validateMsg.password}
            </ValidateWord>
          </s.ValidateWrapper>
        )}

        <BigButton
          label={step === LOGIN_STEP.SETUP_PASSKEY ? "Setup" : "Login"}
          onClickBtn={handleClick}
          data-testid="auth-signin-email-button-click"
        />
      </s.InputWrapper>
      {step !== LOGIN_STEP.SETUP_PASSKEY && (
        <cs.Bottom>
          <UnderlineText
            id="dw_login_button_forward_email"
            color={COLORS.BUTTONS1}
            fontSize={14}
            onClick={() => onChangeStep(LOGIN_STEP.INPUT_EMAIL)}
            data-testid="auth-signin-email-forward-email-change-step"
          >
            Go Back
          </UnderlineText>
          <ForgotPassword loginInfo={loginInfo} onChangeStep={onChangeStep} />
        </cs.Bottom>
      )}
    </>
  );
}
